import React, { memo, useCallback, useState } from "react";

import { SparkLineCell, type SparkLineCellProps } from "./index";
import { useRealtimeMarketData } from "~hooks/ticker-chart";
import type { OhlcvPoint, PricePoint } from "~types/types";
import { mergePoints } from "~utils/ticker-chart";

interface RealtimeSparkLineCellProps extends SparkLineCellProps {
  readonly ticker: string;
}

function RealtimeSparkLineCellInner({
  ticker,
  data: initialData,
  ...rest
}: RealtimeSparkLineCellProps) {
  const [data, setData] = useState(initialData);

  const handlePoint = useCallback((point: PricePoint | OhlcvPoint) => {
    if (!("value" in point)) return;

    setData((prev) => mergePoints(prev, [point]));
  }, []);

  useRealtimeMarketData({
    ticker,
    chartType: "line",
    enableRealTime: true,
    onPoint: handlePoint,
  });

  return <SparkLineCell {...rest} data={data} />;
}

RealtimeSparkLineCellInner.displayName = "RealtimeSparkLineCell";

export const RealtimeSparkLineCell = memo(RealtimeSparkLineCellInner);
